import { checkauth } from '../Helper';

const Reviews = () => import('../views/reviews/Index.vue');

const guard = (to, from, next) => {
	checkauth().then(response => (response ? next() : next('/login')));
};

export default [{ path: '/ecommerce/reviews', name: 'reviews', component: Reviews, beforeEnter: guard }];
